






























































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Maintenance extends Vue {
    intervalId: number | null = null;

    mounted() {
        this.intervalId = window.setInterval(() => {
            window.location.reload();
        }, 30000);
    }

    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    retry() {
        window.location.reload();
    }
}
